import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireMultivaluemap } from "/Users/psenger/Developer/multivalue-map/src/com/cngr/multivaluemap/index.js";
var multivaluemapExports = requireMultivaluemap();
export { multivaluemapExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(multivaluemapExports);